<!--
  @Author: Caroline
  @Desc: 找回密码
  @Date: 2024-06-19
-->
<template>
  <div class="page-password">
    <div class="page-title" v-if="isHyVoGoLogo">
      <div class="image-logo">
        <img src="../../../static/login/img_password_text.png" alt="" />
      </div>
      <div class="image-bg">
        <img src="../../../static/login/img_password_pic.png" alt="" />
      </div>
    </div>

    <div class="information">
      <div class="form-con " v-show="stepIndex === 0">
        <div class="find-title">找回密码</div>
        <div id="findBlock">
          <el-form
            :model="codeLoginParam"
            :rules="rulesSms"
            ref="codeLoginParam"
          >
            <el-form-item class="login-form-item">
              <el-input v-model="accountAndPwdParam.loginName" :disabled="true">
                <div slot="prefix" class="icon-block">
                  <img
                    src="../../../static/login/ic_login_account.png"
                    alt="慧用工"
                  />
                </div>
              </el-input>
            </el-form-item>

            <el-form-item class="login-form-item">
              <el-input v-model="accountAndPwdParam.mobile" :disabled="true">
                <div slot="prefix" class="icon-block">
                  <img
                    src="../../../static/login/icon_login_phone.png"
                    alt="慧用工"
                  />
                </div>
              </el-input>
            </el-form-item>

            <!-- 网易易盾 -->
            <div
              id="captchaAccountNumber"
              v-if="defaultSwitch.isShowAccountNumberNetEase"
            ></div>

            <!-- 获取登陆验证码 -->
            <el-form-item
              class="form-item-password"
              prop="smsCode"
              v-if="defaultSwitch.getCodeVisible"
            >
              <div class="password-block">
                <el-input
                  placeholder="请输入验证码"
                  v-model="codeLoginParam.smsCode"
                  :maxlength="6"
                >
                  <div slot="prefix" class="icon-block">
                    <img
                      src="../../../static/login/icon_login_code.png"
                      alt="慧用工"
                    />
                  </div>
                </el-input>
              </div>
              <span
                class="btnLargeLineColor btnHeight40"
                @click="getCodeOpera"
                >{{ defaultSwitch.getCodeText }}</span
              >
            </el-form-item>
          </el-form>

          <div class="login-btn" @click="xhrFindNext('codeLoginParam')">
            找回密码
          </div>
        </div>
      </div>

      <div class="form-con" v-show="stepIndex === 1">
        <div class="find-title">重置密码</div>
        <div id="resetBlock">
          <el-form
            :model="paramChangePwd"
            :rules="rulesPwd"
            ref="paramChangePwd"
          >
            <el-form-item class="login-form-item">
              <el-input v-model="paramChangePwd.loginName" :disabled="true">
                <div slot="prefix" class="icon-block">
                  <img
                    src="../../../static/login/ic_login_account.png"
                    alt="慧用工"
                  />
                </div>
              </el-input>
            </el-form-item>

            <el-form-item class="login-form-item" prop="newPwd">
              <el-input
                v-model="paramChangePwd.newPwd"
                placeholder="请输入新密码"
                type="password"
                clearable
              >
                <div slot="prefix" class="icon-block">
                  <img
                    src="../../../static/login/ic_login_password.png"
                    alt="慧用工"
                  />
                </div>
              </el-input>
            </el-form-item>

            <el-form-item class="login-form-item" prop="confirmPwd">
              <el-input
                v-model="paramChangePwd.confirmPwd"
                placeholder="再次输入新密码"
                type="password"
                clearable
              >
                <div slot="prefix" class="icon-block">
                  <img
                    src="../../../static/login/ic_login_password.png"
                    alt="慧用工"
                  />
                </div>
              </el-input>
            </el-form-item>
          </el-form>

          <div class="login-btn" @click="xhrChangePwd('paramChangePwd')">
            找回密码
          </div>
        </div>
      </div>

      <div class="form-con" v-show="stepIndex === 2">
        <img
          class="success-img"
          src="../../../static/login/pic_state_green.png"
          alt=""
        />
        <div class="find-title">密码重置成功</div>
        <div class="jump">请返回登录页（{{ jumpSecond }}s），重新登录</div>
      </div>
    </div>
  </div>
</template>

<script>
import RULES from "../../FormVerification/index";
import { HTTP_CODE } from "../../../build/axios_constants";
import { getNetEaseYiDunStatus } from "./../../filters/filters";
import md5 from "js-md5";
import { NOT_OEM_LIST } from "../../service/businessConsts";

export default {
  name: "find-password",
  data() {
    return {
      rulesSms: RULES.rulesFindPassword,
      rulesPwd: RULES,
      paramChangePwd: {
        loginName: "",
        newPwd: "",
        confirmPwd: ""
      }, // 修改密码参数

      accountAndPwdParam: {
        loginName: "",
        passWord: "",
        mobile: "",
        smsCode: ""
      },

      codeLoginParam: {
        smsCode: "",
        validate: ""
      },

      defaultSwitch: {
        getCodeVisible: true, //验证码回显
        getCodeDisabled: false,
        getCodeText: "获取验证码",
        isShowAccountNumberNetEase: false // 网易校验
      },
      timer: null,
      timerJump: null,
      stepIndex: 0,
      jumpSecond: 3,
      isHyVoGoLogo: null
    };
  },

  created() {
    this.accountAndPwdParam.loginName = this.$route.query.account;
    this.accountAndPwdParam.mobile = this.$route.query.phone;
    this.paramChangePwd.loginName = this.$route.query.account;
    this.isHyVoGoLogo = NOT_OEM_LIST.includes(window.location.hostname);
  },

  mounted() {},

  methods: {
    xhrFindNext(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let param = {
            loginName: this.$route.query.account,
            smsCode: this.codeLoginParam.smsCode
          };
          this.$http.postSmsCodeValidate(param).then(res => {
            if (res.statusCode === HTTP_CODE.suc) {
              this.stepIndex = 1;
            }
          });
        }
      });
    },

    // xhr -- 修改密码
    xhrChangePwd(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let param = {
            loginName: this.$route.query.account,
            newPwd: this.paramChangePwd.newPwd,
            confirmPwd: this.paramChangePwd.confirmPwd
          };
          param.newPwd = md5(param.newPwd);
          param.confirmPwd = md5(param.confirmPwd);
          this.$http.postChangePwd(param).then(res => {
            if (res.statusCode === HTTP_CODE.suc) {
              this.stepIndex = 2;
              var _this = this,
                secondNum = 3;

              _this.timerJump = setInterval(() => {
                secondNum--;
                _this.jumpSecond = secondNum;

                if (secondNum <= 0) {
                  clearInterval(_this.timerJump);
                  _this.$router.push({
                    path: "/"
                  });
                }
              }, 1000);
            }
          });
        } else {
          console.log("error submit!!", this.paramChangePwd);
          return false;
        }
      });
    },

    // 获取验证码
    getCodeOpera() {
      if (this.defaultSwitch.getCodeDisabled) {
        return;
      }
      if (this.defaultSwitch.getCodeText === "重新发送") {
        this.defaultSwitch.isShowAccountNumberNetEase = true;
        this.initNetEase();
      }
      this.defaultSwitch.isShowAccountNumberNetEase = true;
      this.initNetEase();
    },

    // 初始化网易易盾
    initNetEase() {
      const self = this;
      initNECaptcha(
        {
          element: "#captchaAccountNumber",
          captchaId: "2d2fc49e1af44cdc9851d14174964b69", // 网易易盾
          mode: "float",
          // apiVersion: 2,
          onVerify: (err, data) => {
            // 当验证失败时, 内部会自动 refresh 方法, 无需手动再调用一次
            if (err) return;
            // 以下为业务侧逻辑
            this.codeLoginParam.validate = data.validate;
            if (data && data.validate) {
              if (this.itemIndex === 0) {
                this.defaultSwitch.getCodeVisible = true;
              }
              this.xhrGetCode();
            }
          }
        },
        function onload(instance) {
          self.captchaIns = instance;
        },
        function onerror(err) {
          self.$message.error(getNetEaseYiDunStatus(err.code));
          self.defaultSwitch.isShowAccountNumberNetEase = false;
        }
      );
    },

    // xhr -- 获取验证码
    xhrGetCode() {
      let param = {
          loginName: this.$route.query.account,
          validate: this.codeLoginParam.validate
        },
        self = this;
      this.$http
        .postFindPwdGetCode(param)
        .then(res => {
          if (res.statusCode === HTTP_CODE.suc) {
            let getCodeTextTemp = 59;
            if (self.defaultSwitch.getCodeDisabled) {
              return;
            }
            this.timer = setInterval(() => {
              self.defaultSwitch.getCodeDisabled = true;
              self.defaultSwitch.getCodeText = getCodeTextTemp--;
              getCodeTextTemp = getCodeTextTemp--;
              self.defaultSwitch.getCodeText =
                self.defaultSwitch.getCodeText + "s";
              if (getCodeTextTemp <= 0) {
                self.defaultSwitch.getCodeText = "重新获取";
                self.defaultSwitch.getCodeDisabled = false;
                self.defaultSwitch.isDisabledBtn = false;
                self.defaultSwitch.isShowAccountNumberNetEase = false;
                clearInterval(this.timer);
              }
            }, 1000);
          } else {
            self.defaultSwitch.isShowAccountNumberNetEase = false;
          }
        })
        .catch(err => {});
    }
  }
};
</script>

<style lang="scss">
#findBlock,
#resetBlock {
  .login-form-item {
    .el-input {
      width: 360px;
      height: 40px;
      .el-input__inner {
        height: 40px;
        width: 360px;
      }
    }
    .el-input--prefix .el-input__inner {
      padding-left: 47px;
    }
  }
  .password-block {
    .el-input__inner {
      height: 40px;
      width: 256px;
    }
    .el-input--prefix .el-input__inner {
      padding-left: 47px;
    }
  }

  .form-item-password {
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
    }
  }
}
</style>

<style scoped lang="scss">
@import "../../styles/variable";

.page-password {
  margin: 0;
  padding: 0;
  overflow-x: hidden;

  .page-title {
    width: 100%;
    min-width: 1440px;
    height: 126px;
    background: linear-gradient(343deg, #f4f6fa 0%, #d9e2f3 100%), #ffffff;
    position: relative;
    .image-logo {
      width: 261px;
      height: 64px;
      position: absolute;
      top: 50%;
      left: 154px;
      transform: translate(0, -50%);
    }
    .image-bg {
      width: 626px;
      height: 100%;
      position: absolute;
      top: 0;
      right: 0;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }

  .information {
    width: 1136px;
    min-height: 600px;
    background: #fff;
    margin: 0 auto;
    margin-top: 24px;
    border-radius: 2px;
    padding: 51px 0 0;
    display: flex;
    justify-content: center;

    .form-con {
      margin-top: 22px;
      padding: 0 45px;
      .icon-block {
        width: 37px;
        height: 37px;
        background: #fafafa;
        border-radius: 4px 0px 0px 4px;
        position: relative;
        left: -4px;
        top: 2px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          position: relative;
          width: 16px;
          height: 16px;
        }
      }

      .find-title {
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        font-size: 24px;
        color: #272727;
        line-height: 33px;
        margin-bottom: 30px;
      }

      .btnHeight40 {
        height: 40px;
        line-height: 40px;
        margin-left: 10px;
        width: 92px;
      }

      .login-btn {
        width: 360px;
        height: 40px;
        margin-top: 40px;
        margin-bottom: 64px;
        background: $button-confirm-color;
        border-radius: 4px;
        font-size: 14px;
        color: #fff;
        outline: none;
        line-height: 40px;
      }

      .success-img {
        width: 128px;
        height: 128px;
        margin-top: 130px;
      }

      .jump {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #8c8c8c;
        line-height: 20px;
      }
    }
  }

  #captchaAccountNumber {
    margin-bottom: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/findPassword.vue